import { render } from "./AccountMain.vue?vue&type=template&id=74ad7054&scoped=true"
import script from "./AccountMain.vue?vue&type=script&lang=js"
export * from "./AccountMain.vue?vue&type=script&lang=js"

import "./AccountMain.vue?vue&type=style&index=0&id=74ad7054&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ad7054"]])

export default __exports__